import { AHText, Box, Circle } from "arkh";
import React from "react";
import { useFragment, graphql } from "react-relay";

import { TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion$key } from "./__generated__/TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion.graphql";

export function TeamScheduleRoutineOccasionListItemBadge(props: {
  occasion: TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion$key;
}) {
  const occasion = useFragment(
    graphql`
      fragment TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion on RoutineOccasion {
        issueCount
      }
    `,
    props.occasion
  );

  const count = occasion?.issueCount ?? 0;

  if (count === 0) {
    return null;
  }
  return (
    <Box style={{ position: "absolute", top: -11, right: -11 }}>
      <Circle allowGrow color="negative" size="small">
        <AHText
          type="info-small"
          color="text-inverted"
          spaceHorizontal="xxsmall"
          textAlign="center"
          numberOfLines={1}
        >
          {count}
        </AHText>
      </Circle>
    </Box>
  );
}
